(function() {
  function nslCelebrityProofFix() {
    var fallbackHero = document.querySelector('.nsl-friends-hub-live');
    var nativeHero = document.querySelector('.nsl-celebrity-hero');

    if (fallbackHero && nativeHero) {
      fallbackHero.parentNode.removeChild(fallbackHero);
    }

    if ((!document.querySelector('.nsl-celebrity-page') && !document.querySelector('.nsl-celebrity-grid')) || document.getElementById('nsl-celebrity-proof-fix')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'nsl-celebrity-proof-fix';
    style.textContent = [
      '.nsl-celebrity-page__media .image-wrap{aspect-ratio:2/3!important;height:auto!important;min-height:clamp(360px,52vw,720px);padding-bottom:0!important;position:relative!important;}',
      '.nsl-celebrity-page__media image-element{display:block!important;height:100%!important;inset:0!important;position:absolute!important;width:100%!important;}',
      '.nsl-celebrity-page__media .image-wrap img{height:100%!important;object-fit:cover!important;width:100%!important;}',
      '.nsl-celebrity-grid .grid__item{margin-bottom:72px!important;padding-bottom:8px!important;}',
      '.nsl-celebrity-grid .grid__item:nth-child(n+4)>div:first-of-type{margin-top:64px!important;}',
      '.nsl-celebrity-grid .btn{margin-bottom:4px!important;}',
      '@media only screen and (max-width:768px){.nsl-celebrity-page__media .image-wrap{min-height:min(135vw,620px);}.nsl-celebrity-grid .grid__item:nth-child(n+2)>div:first-of-type{margin-top:38px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nslCelebrityProofFix);
  } else {
    nslCelebrityProofFix();
  }
  document.addEventListener('page:loaded', nslCelebrityProofFix);
})();
